



























































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import TabChange from './tabChange.vue'
import Empty from '@/components/Empty/index.vue'
import {
  getOrderDetailPage,
  queryOrderDetailById,
  completeOrder,
  deliveryOrder,
  orderCancel,
  orderReject,
  orderAccept,
  getOrderListBy,
} from '@/api/order'
import {
  cancelOrderReasonList,
  cancelrReasonList,
  orderList,
} from '@/utils/staticData'

@Component({
  components: {
    HeadLable,
    InputAutoComplete,
    TabChange,
    Empty,
  },
})
export default class extends Vue {
  private defaultActivity: any = 0
  private orderStatics = {}
  private row = {}
  private isAutoNext = true
  private isTableOperateBtn = true
  private currentPageIndex = 0 //记录查看详情数据的index
  private orderId = '' //订单号
  private input = '' //搜索条件的订单号
  private phone = '' //搜索条件的手机号
  private valueTime = []
  private dialogVisible = false //详情弹窗
  private cancelDialogVisible = false //取消，拒单弹窗
  private cancelDialogTitle = '' //取消，拒绝弹窗标题
  private cancelReason = ''
  private remark = '' //自定义原因
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  private diaForm = []
  private isSearch: boolean = false
  private orderStatus = 0 //列表字段展示所需订单状态,用于分页请求数据
  private dialogOrderStatus = 0 //弹窗所需订单状态，用于详情展示字段
  private cancelOrderReasonList = cancelOrderReasonList

  private cancelrReasonList = cancelrReasonList
  private orderList = orderList

  created() {
    this.init(Number(this.$route.query.status) || 0)
  }

  mounted() {
    //如果有值说明是消息通知点击进来的
    if (
      this.$route.query.orderId &&
      this.$route.query.orderId !== 'undefined'
    ) {
      this.goDetail(this.$route.query.orderId, 2)
    }
    if (this.$route.query.status) {
      this.defaultActivity = this.$route.query.status
    }
  }

  initFun(orderStatus) {
    this.page = 1
    this.init(orderStatus)
  }

  change(activeIndex) {
    if (activeIndex === this.orderStatus) return
    this.init(activeIndex)
    this.input = ''
    this.phone = ''
    this.valueTime = []
    this.dialogOrderStatus = 0
    this.$router.push('/order')
    console.log(activeIndex, '接收到了子组件的index')
  }

  //获取待处理，待派送，派送中数量
  getOrderListBy3Status() {
    getOrderListBy({}).then((res) => {
      if (res.data.code === 1) {
        this.orderStatics = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
    // .catch((err) => {
    //   this.$message.error('请求出错了：' + err.message)
    // })
  }
  //初始化数据
  init(activeIndex: number = 0, isSearch?) {
    this.isSearch = isSearch
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      number: this.input || undefined,
      phone: this.phone || undefined,
      beginTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[0]
          : undefined,
      endTime:
        this.valueTime && this.valueTime.length > 0
          ? this.valueTime[1]
          : undefined,
      status: activeIndex || undefined,
    }
    getOrderDetailPage({ ...params }).then((res) => {
      if (res.data.code === 1) {
        this.tableData = res.data.data.records
        this.orderStatus = activeIndex
        this.counts = Number(res.data.data.total)
        this.getOrderListBy3Status()
        if (
          this.dialogOrderStatus === 2 &&
          this.orderStatus === 2 &&
          this.isAutoNext &&
          !this.isTableOperateBtn &&
          res.data.data.records.length > 1
        ) {
          const row = res.data.data.records[0]
          this.goDetail(row.id, row.status, row)
        } else {
          return null
        }
      } else {
        this.$message.error(res.data.msg)
      }
    })
    // .catch((err) => {
    //   this.$message.error('请求出错了：' + err.message)
    // })
  }
  //获取订单状态
  getOrderType(row: any) {
    if (row.status === 1) {
      return '待付款'
    } else if (row.status === 2) {
      return '待处理'
    } else if (row.status === 3) {
      return '待派送'
    } else if (row.status === 4) {
      return '派送中'
    } else if (row.status === 5) {
      return '已完成'
    } else if (row.status === 6) {
      return '已取消'
    } else {
      return '退款'
    }
  }

  // 查看详情
  async goDetail(id: any, status: number, row?: any) {
    this.diaForm = []
    this.dialogVisible = true
    this.dialogOrderStatus = status
    this.orderId = id
    const { data } = await queryOrderDetailById({ orderId: id })
    this.diaForm = data.data
    this.row = row || { id: this.$route.query.orderId, status: status }
    if (this.$route.query.orderId) {
      this.$router.push('/order')
    }
  }

  //打开拒单弹窗
  orderReject(row: any) {
    this.cancelDialogVisible = true
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    this.cancelDialogTitle = '拒绝'
    this.dialogVisible = false
    this.cancelReason = ''
  }

  //接单
  orderAccept(row: any) {
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    orderAccept({ id: this.orderId }).then((res) => {
      if (res.data.code === 1) {
        this.$message.success('操作成功')
        this.orderId = ''
        this.dialogVisible = false
        this.init(this.orderStatus)
      } else {
        this.$message.error(res.data.msg)
      }
    })
    // .catch((err) => {
    //   console.log(err, '----')
    //   this.$message.error('请求出错了：' + err.message)
    // })
  }

  //打开取消订单弹窗
  cancelOrder(row: any) {
    this.cancelDialogVisible = true
    this.orderId = row.id
    this.dialogOrderStatus = row.status
    this.cancelDialogTitle = '取消'
    this.dialogVisible = false
    this.cancelReason = ''
  }

  //确认取消或拒绝订单并填写原因
  confirmCancel() {
    if (!this.cancelReason) {
      return this.$message.error(`请选择${this.cancelDialogTitle}原因`)
    } else if (this.cancelReason === '自定义原因' && !this.remark) {
      return this.$message.error(`请输入${this.cancelDialogTitle}原因`)
    }

    ;(this.cancelDialogTitle === '取消' ? orderCancel : orderReject)({
      id: this.orderId,
      [this.cancelDialogTitle === '取消' ? 'cancelReason' : 'rejectionReason']:
        this.cancelReason === '自定义原因' ? this.remark : this.cancelReason,
    }).then((res) => {
      if (res.data.code === 1) {
        this.$message.success('操作成功')
        this.cancelDialogVisible = false
        this.orderId = ''
        this.init(this.orderStatus)
      } else {
        this.$message.error(res.data.msg)
      }
    })
    // .catch((err) => {
    //   this.$message.error('请求出错了：' + err.message)
    // })
  }

  // 派送，完成
  cancelOrDeliveryOrComplete(status: number, id: string) {
    const params = {
      status,
      id,
    }
    ;(status === 3 ? deliveryOrder : completeOrder)(params).then((res) => {
      if (res.data.code === 1) {
        this.$message.success('操作成功')
        this.orderId = ''
        this.dialogVisible = false
        this.init(this.orderStatus)
      } else {
        this.$message.error(res.data.msg)
      }
    })
    // .catch((err) => {
    //   this.$message.error('请求出错了：' + err.message)
    // })
  }

  handleClose() {
    this.dialogVisible = false
  }
  //改变当前一页展示数量
  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init(this.orderStatus)
  }
  //改变当前页码数
  private handleCurrentChange(val: any) {
    this.page = val
    this.init(this.orderStatus)
  }
}
